export default __webpack_public_path__ + "static/media/ph1.1b00013c.png";